import { createSelector } from '@reduxjs/toolkit';

const getRootEntity = ({ newSales }) => {
  return newSales;
};

export const getLoaded = createSelector([getRootEntity], ({ loaded }) => {
  return loaded;
});

export const getNewSales = createSelector([getRootEntity], ({ newSales }) => {
  return newSales;
});

export const getNewSalesLeft = createSelector([getRootEntity], ({ newSalesLeft }) => {
  return newSalesLeft;
});

export const getLoadMoreData = createSelector([getRootEntity], ({ isFetching, page, newSalesLeft }) => {
  return {
    isFetching,
    page,
    newSalesLeft,
  };
});
